import React from 'react';

import PerfectScrollbar from 'react-perfect-scrollbar';

import ChartStatisticalVol from '../chart/chartStatisticalVol'
import ChartPBDongTien from '../chart/chartPBDongTien'

function PanelDongTien({ indexDetail, pbDongTien, t, theme }) {

  console.log(indexDetail)

  return (
    <PerfectScrollbar
      className="mt-2"
      style={{ height: 'calc(100vh - 180px)' }}
    >
      <p
        className="txt-content font-weight-bold fz-13 mt-2 mb-0"
        style={{ lineHeight: '14px' }}
      >
        {t('algo.bdkt.txt-advance-decline-nochange')}
      </p>
      <ChartStatisticalVol indexDetail={indexDetail} t={t} theme={theme}/>
      <p
        className="txt-content font-weight-bold fz-13 mt-3 mb-2"
        style={{ lineHeight: '14px' }}
      >
        {t('algo.bdkt.txt-money-flow-distribution')}
      </p>
      {
        pbDongTien && <ChartPBDongTien pbDongTien={pbDongTien} t={t} theme={theme}/>
      }
    </PerfectScrollbar>
  );
}

export default PanelDongTien;
